exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_logo__M4qZr{display:flex;align-items:center;align-content:center;justify-content:center}.style_logo__M4qZr img{height:auto;width:auto}.style_logo__M4qZr .style_disabled__LoIvK{-webkit-filter:grayscale(1);filter:grayscale(1);opacity:.4}", ""]);

// exports
exports.locals = {
	"logo": "style_logo__M4qZr",
	"disabled": "style_disabled__LoIvK"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/Logo/style.less
// module id = 1683
// module chunks = 8